import {
  DropdownMenuCheckboxItem,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { MUSCLE_ACTION_SECTIONS } from "@/lib/exercise-muscle-actions";

type Props = {
  selected: string[];
  onToggle: (action: string, checked: boolean) => void;
  onClear: () => void;
  checkboxClassName?: string;
};

export default function GroupedMuscleActionFilterItems({
  selected,
  onToggle,
  onClear,
  checkboxClassName = "data-[state=checked]:bg-gray-100 data-[state=checked]:font-semibold",
}: Props) {
  return (
    <>
      {MUSCLE_ACTION_SECTIONS.map((section) => (
        <div key={section.id}>
          <DropdownMenuLabel className="text-xs text-muted-foreground">{section.label}</DropdownMenuLabel>
          {section.actions.map((action) => (
            <DropdownMenuCheckboxItem
              key={action}
              checked={selected.includes(action)}
              onCheckedChange={(checked) => onToggle(action, Boolean(checked))}
              onSelect={(e) => e.preventDefault()}
              className={checkboxClassName}
            >
              {action}
            </DropdownMenuCheckboxItem>
          ))}
        </div>
      ))}
      <DropdownMenuSeparator />
      <DropdownMenuItem
        onSelect={(e) => {
          e.preventDefault();
          onClear();
        }}
      >
        Clear
      </DropdownMenuItem>
    </>
  );
}
